import React from 'react'
import Profile from './Profile'

const index = ({func,logoutfun,mobile}) => <Profile func={()=>func()} logoutfun={logoutfun} mobile={mobile}/> 


export default index